<template>
    <div id="extra-info">
        <section class="section">
            <div class="container">
                <!-- <div id="second-banner" class="project-add-banner" data-sal="slide-up" data-sal-duration="1000">
                    <div class="thumbnail col-sm-hidden">
                        <img :src="notebookImg" alt="¿Cuánto capital se requiere?">
                    </div>
                    <div class="content">
                        <span class="subtitle primary">¿Cuánto capital se requiere?</span>
                        <h3 class="font-weight-100 white mb-2">
                            Se estima que a <span class="bold">nivel global</span>,
                            se requiera una inversión directa 
                            de <span class="bold primary">$125T USD al 2050*</span> 
                            para evitar daños irreversibles provocados 
                            por <span class="bold">cambio climático</span>.
                        </h3>
                        <h6 class="white">*Fuente: <a @click.stop="redirectThirdSite('https://www.gfanzero.com/netzerofinancing')" class="text-decoration-underline">GFANZ</a></h6>
                    </div>
                </div> -->
                <div id="first-banner" class="project-add-banner row" data-sal="slide-up" data-sal-duration="1000">
                    <div class="col-sm-12 col-md-8 col-lg-8">
                        <span class="subtitle primary bold">Cambio climático.</span>
                        <h3 class="font-weight-100 mb-2">
                            Se estima que a <span class="bold">nivel global,</span>
                            se requiera una inversión directa 
                            de <span class="bold">$125T USD al 2050*</span> 
                            para evitar daños irreversibles provocados 
                            por <span class="bold">cambio climático</span>.
                        </h3>
                        <h6 class="">*Fuente: <a @click.stop="redirectThirdSite('https://www.gfanzero.com/netzerofinancing')" class="text-decoration-underline">GFANZ</a></h6>
                    </div>
                    <!-- <div class="thumbnail fix-thumbnail col-sm-hidden">
                        <img :src="earthImg" class="fix-img" alt="¿Por qué es importante combatir el cambio climático?">
                    </div> -->
                </div>
                <div id="second-banner" class="project-add-banner text-align-last" data-sal="slide-up" data-sal-duration="1000">
                    <div class="content">
                        <span class="subtitle primary">Inclusión financiera.</span>
                        <h3 class="font-weight-100 white mb-2 text-align-last">
                            <span class="bold">No dejar a nadie atrás,</span> promesa central
                            y transformadora de la Agenda 2030 para el <span class="bold">Desarrollo Sostenible</span> (ODS).
                        </h3>
                        <h6 class="white">*Fuente: <a @click.stop="redirectThirdSite('https://unsdg.un.org/es/2030-agenda/universal-values/leave-no-one-behind')" class="text-decoration-underline">UNSDG</a></h6>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "ExtraInfo",
    components: {
    },
    data() {
        return {
            notebookImg: "https://cdn.redgirasol.com/nuevo_portal/extras/extra-notebook.png",
            earthImg: "https://cdn.redgirasol.com/nuevo_portal/extras/extra-earth-half-green.png"
        }
    }
}

</script>

<style scoped>

.section {
    padding-top: 8rem;
}
#first-banner.project-add-banner {
    padding-right: 0 !important;
    padding: 3rem;
    background-image: url(https://cdn.redgirasol.com/nuevo_portal/extras/extra-earth-half-green.png);
    background-color: var(--color-gray-6);
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: 35%;
    background-position-y: bottom;
}

#first-banner.project-add-banner > div.thumbnail {
    /* margin: -141px 0 -250px !important; */
}
#second-banner.project-add-banner {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/extras/extra-people.png") !important;
    padding: 4rem;
    text-align: center;
    background-position: center;
    background-size: cover;
}
    #second-banner.project-add-banner > div.thumbnail {
        margin-right: 2.5rem;
    }

@media (max-width: 767px) {
    #first-banner.project-add-banner {
        padding: 1rem;
    }
}

/* .fix-img {
    max-width: 65% !important;
    border-radius: 0 0 30px 0;
}

.fix-thumbnail {
    text-align: right;
} */

</style>